import { render, staticRenderFns } from "./viewCustomizedSku.vue?vue&type=template&id=6dd46961&scoped=true"
import script from "./viewCustomizedSku.vue?vue&type=script&lang=js"
export * from "./viewCustomizedSku.vue?vue&type=script&lang=js"
import style0 from "./viewCustomizedSku.vue?vue&type=style&index=0&id=6dd46961&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd46961",
  null
  
)

export default component.exports